// extracted by mini-css-extract-plugin
export default {"container":"ChooseCompany_container__Yk1sw","listWrapper":"ChooseCompany_listWrapper__RJ+6Y","listItem":"ChooseCompany_listItem__-6L5l","link":"ChooseCompany_link__LMni8"};